import { Paths } from 'services/navigation/paths';
import {
  mapSourcingStatuses,
  SOURCING_STATUS_MESSAGES
} from 'modules/sourcing-shared/utils/mapSourcingStatuses';
import { SourcedCandidateStatus } from 'generated-graphql/types';
import { Link } from '@mui/material';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useDrawer } from 'services/drawer/hooks';
import { DrawerComponentType } from 'services/drawer/types';
import { deleteSearchParams } from 'services/navigation/paths';

export const SourcingCandidateStatusTextComponent: React.FC<{
  status: SourcedCandidateStatus;
  candidateId: string | null;
  candidateBatchId: string;
}> = ({ status, candidateId, candidateBatchId }) => {
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const { openDrawer } = useDrawer();

  const handleClick = (e: React.MouseEvent) => {
    // Check if we're already on the correct Analyse page
    const isOnAnalysePage =
      location.pathname === `${Paths.ANALYSE}/${candidateBatchId}`;

    if (isOnAnalysePage && candidateId) {
      // Prevent default navigation
      e.preventDefault();

      // Update search params with both tab and candidateId
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.set('tab', 'Source_candidates');
      newSearchParams.set('candidateId', candidateId);
      setSearchParams(newSearchParams);

      // Open drawer directly since we're already on the page
      openDrawer({
        drawerContentType: DrawerComponentType.CandidateReport,
        drawerComponentProps: {
          candidateId,
          candidateTableIndex: null,
          candidateIds: null
        },
        onClose: () => {
          deleteSearchParams({
            searchParams,
            key: 'candidateId',
            setSearchParams
          });
        }
      });
    }
    // Otherwise, let the default href navigation happen
  };

  if (candidateId) {
    return (
      <Link
        href={`${Paths.ANALYSE}/${candidateBatchId}?tab=Source_candidates&candidateId=${candidateId}`}
        onClick={handleClick}
      >
        Candidate applied
      </Link>
    );
  }

  const sourcingStatus = mapSourcingStatuses(status);
  return SOURCING_STATUS_MESSAGES[sourcingStatus];
};
